import { WarningAltFilled } from "@carbon/icons-react";
import i18next from "../../i18n";

// N7: single, consistent consultation-period notice for the supplier offer views
// (previously three different styles/texts across SellerOffer, JointSellerOffer
// and Offer). Explains that offers are blocked but Q&A via chat is available.
const ConsultationNotice = () => (
  <div className="mt-4 flex items-start space-x-3 rounded-lg border border-yellow-200 bg-yellow-50 p-4">
    <WarningAltFilled size={20} className="flex-shrink-0 text-yellow-500" />
    <p className="text-xs text-gray-700">
      {i18next.t("tenders.seller.consultationPeriod")}
    </p>
  </div>
);

export default ConsultationNotice;
